import { useEffect, useState } from "react"

import CustomizedImageInput from "../CustomizedImageInput"
import { ValidateInput } from "../../utilities"
import {ObservationImages} from "../../constants"
import { useTranslation } from 'react-i18next';

function CustomizedTextArea(props) {
    const { t: translate } = useTranslation();
    const {
        label,
        name,
        required,
        error,
        schema
    } = props

    const [isObservation, setIsObservation] = useState(false)
    const [isShowImageUpload, setIsShowImageUpload] = useState(false)
    const [textValue, setTextValue] = useState("")
    const [isValid, setIsValid] = useState(!error)
    const [numberOfImage, setNumberOfImage] = useState([{id:1, filename: ""}])

    const validateInput = (value) => {
        const valid = ValidateInput(schema, { [name]: value })
        setIsValid(valid)
    }

    const onTextAreaChange = (e) => {
        const value = e.target.value
        setTextValue(value)
        validateInput(value)

        if (value.length > 0 && isObservation) {
            setIsShowImageUpload(true)
        }
        else {
            setIsShowImageUpload(false)
        }
    }

    const addImage = (id, filename) => {
        const temp = numberOfImage
        temp.forEach(t => {
            if(t.id === id){
                t.filename = filename
            }
        })
        const currentLength = numberOfImage.length
        if (currentLength < 4) {
            temp.push({id: numberOfImage.length + 1, filename: ""})
        }
        setNumberOfImage([...temp])
    }

    const handleDeleteImage = (id) => {
        const temp = []
        let currentImage = ObservationImages.getImageOfObservation(name)
        currentImage = currentImage.filter(image => image.id !== id)
        currentImage.forEach(image => {
            ObservationImages.removeImage(image)
        })
        currentImage.forEach((image, index) => {
            temp.push({id: index+1, filename: image.image.name})
            ObservationImages.addImage({
                id: index+1,
                questionId: image.questionId,
                image: image.image
            })
        })
        temp.push({id: temp.length + 1, filename: ""})
        setNumberOfImage([...temp])
    }

    useEffect(() => {
        if (label.indexOf("Observation") > -1 || label.indexOf("Oservation") > -1) {
            setIsObservation(true)
        }
    }, [])

    useEffect(() => {
        setIsValid(!error)
    }, [error])

    return <>
        <div className={`form-group form-element ${!isValid ? "error" : ""}`}>
            <label htmlFor={name}>{label} {required ? <span className='text-danger'>*</span> : null}</label>
            <textarea className="form-control" name={name} id={name} rows="3" value={textValue} onChange={onTextAreaChange}></textarea>
        </div>
        {isShowImageUpload ? <div className="form-group form-element">
            <label>{translate('photoRequire')}</label>
            <div className="w-100 d-flex flex-wrap justify-content-between align-items-center">
                {numberOfImage.map((id) => {
                    return <div key={id.id} className="w-50 h-100">
                        <CustomizedImageInput questionId={name} id={id.id} filename={id.filename} onChange={addImage} onDelete={handleDeleteImage} />
                    </div>
                })}
            </div>
        </div> : null}
    </>
}

export default CustomizedTextArea;